import { Link, usePage } from '@inertiajs/react';
import classNames from 'classnames';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { useRouter } from '../router';
import { PageProps } from '../types';
import Container from '../UI/Container';

export function DonationsLayout({
  children,
}: {
  children: ReactNode;
}) {
  const { component } = usePage<PageProps>();

  return (
    <>
      <DonationsHeader component={component} />
      {children}
    </>
  );
}

export function DonationsHeader({
  component,
}: {
  component: string;
}) {
  const { t } = useTranslation();
  const { routes } = useRouter();

  return (
    <div className="bg-white border-b">
      <Container className="!py-3 text-center">
        <div className="space-x-2">
          <Link
            href={routes.donations_page()}
            className={tabClasses({
              active: [
                'Backend/Donations/Donations/DonationsPage',
                'Backend/Donations/Donations/DonationPage',
              ].includes(component),
            })}
          >
            {t('backend:oneoff_donations')}
          </Link>
          <Link
            href={routes.subscriptions_page()}
            className={tabClasses({
              active: [
                'Backend/Donations/Subscriptions/SubscriptionsPage',
                'Backend/Donations/Subscriptions/SubscriptionPage',
                'Backend/Donations/Subscriptions/PaymentsPage',
                'Backend/Donations/Subscriptions/SentMailsPage',
              ].includes(component),
            })}
          >
            {t('backend:recurring_donations')}
          </Link>
        </div>
      </Container>
    </div>
  );
}

function tabClasses({
  active,
}: {
  active?: boolean;
}) {
  return classNames(
    'font-medium py-1 px-2 inline-block rounded',
    active
      ? 'bg-blue-200 text-blue-900 hover:text-blue-900'
      : 'text-blue-700 hover:bg-blue-100 hover:text-blue-900'
  );
}
